import { render, staticRenderFns } from "./ReportCellsTableMobile.vue?vue&type=template&id=38109342&scoped=true"
import script from "./ReportCellsTableMobile.vue?vue&type=script&lang=js"
export * from "./ReportCellsTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38109342",
  null
  
)

export default component.exports